import { Component, OnInit, Input, DoCheck, Optional, HostListener, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, FormGroupDirective, ControlContainer } from '@angular/forms';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { UtilityService } from '../../Shared/services/UtilityService';
import { DropdownOptions } from '../../Shared/Models/DropdownOptions';
import { DropdownListItem } from '../../Shared/Models/DropdownListItem';
import { OnPagingFiltersChangeService } from '../../Shared/services/OnPagingFiltersChange.service';
import { environmentService } from '../../Shared/services/environmentService.Service';
import { environment } from '../../Shared/config/environment';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'BBSF-DropdownList',
  templateUrl: './DropdownList.component.html',
  styleUrls: ['./DropdownList.component.css']
})
export class DropdownListComponent implements OnInit {
  static controlContainerstatic = null;
  // tslint:disable-next-line: max-line-length
  constructor(private onChangeService: OnPagingFiltersChangeService, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public DropdownListControlHost: FormGroupDirective) {
    DropdownListComponent.controlContainerstatic = this.controlContainer;
    console.log(environment["BBSF_AdminUrl"]);
  }
  @Input() group: FormGroup;
  @Input() options: DropdownOptions;
  DropdownListFormControl: AbstractControl;
  dropdownSettings = {};
  SelectedItems: DropdownListItem[]
  SelectedList: any[] = []
  @Output() OnChange = new EventEmitter();
  @Output() onClear = new EventEmitter();

  markAllAsTouched: boolean = false;

  controlChanged: boolean = false;
  validationRules = [];
  validationRulesasync = [];

  ngOnInit() {
    UtilityService.isCreatedBefor = false
    this.SelectedList = this.options.SelectedItems
    this.dropdownSettings = {
      singleSelection: this.options.SingleSelection,
      text: "Select",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: this.options.AllowSearchFilter,
      classes: this.options.Classes,
      disabled: this.options.IsDisabled,
      showCheckbox: this.options.ShowCheckbox,
      enableCheckAll: this.options.EnableCheckAll,
      itemsShowLimit: this.options.ItemsShowLimit,
      allowSearchFilter: this.options.AllowSearchFilter,
      showSelectedItemsAtTop: true,
      limitSelection: this.options.LimitSelection,
      searchPlaceholderText: this.options.Placeholder,
      labelKey: "value",
      primaryKey: "key"
    };

    this.group.addControl(this.options.Name, new FormControl(''));
    this.DropdownListFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);


    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }



    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);

    }
    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);

    this.DropdownListFormControl.setValidators(this.validationRules);
    this.DropdownListFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.DropdownListFormControl.disable();
    }

    this.DropdownListControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })
  }



  ngAfterViewInit(): void {
    this.controlUtility.setAttributeForControl(this.options)
  }


  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }
    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }


  onItemSelect(item) {
    this.onChangeService.ChangeValue(this.options.Name)
    this.OnChange.emit(item)
    console.log(this.DropdownListFormControl.value)
  }
  Clear() {
    console.log("Clear")
    this.DropdownListFormControl.setValue(this.SelectedItems);
    this.onChangeService.ChangeValue(this.options.Name)
    this.OnChange.emit()
  }
  onSelectAll(items) {
    this.SelectedItems = items;
    this.DropdownListFormControl.setValue(this.SelectedItems);
  }
  onDeselect(items) {
    this.DropdownListFormControl.setValue(this.SelectedItems);
    if ((this.SelectedItems.length == 0) && this.options.IsRequired == true) {
      this.DropdownListFormControl.markAsTouched();
      this.DropdownListFormControl.invalid;

    }

  }
  onDeselectAll(items) {
    this.DropdownListFormControl.setValue(this.SelectedItems);
    if ((this.SelectedItems.length == 0) && this.options.IsRequired == true) {
      this.DropdownListFormControl.markAsTouched();
      this.DropdownListFormControl.invalid;

    }
  }

  onDropDownClose() {
    if ((this.SelectedItems == undefined || this.SelectedItems == []) && this.options.IsRequired == true) {
      this.DropdownListFormControl.markAsTouched();
      this.DropdownListFormControl.invalid;

    }
  }

  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.DropdownListFormControl, this.validationRules, this.options)
  }

  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.DropdownListFormControl, this.validationRules, this.options)
  }

  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.DropdownListFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.DropdownListFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.DropdownListFormControl)
  }

}





